module.exports = __webpack_public_path__ + "static/media/leg-right-side.aa912f9f.png";